// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js"
import { Modal } from "flowbite"
import "./confirm_modal"

import "@37signals/lexxy"
